export const SubmitRequestInfoBoxItems = {
  default: {
    download: [
      'app.submitRequest.download.info.first',
      'app.submitRequest.download.info.second',
      'app.submitRequest.download.info.third',
    ],
    upload: [
      'app.submitRequest.upload.info.first',
      'app.submitRequest.upload.info.second',
      'app.submitRequest.upload.info.third',
    ],
    password: [
      'app.submitRequest.password.info.first',
      'app.submitRequest.password.info.second',
      'app.submitRequest.password.info.third',
    ],
    additional: [
      'app.submitRequest.additional.info.first',
      'app.submitRequest.additional.info.second',
      'app.submitRequest.additional.info.third',
    ],
    sterbeurkunde: [
      'app.submitRequest.sterbeurkunde.info.first',
      'app.submitRequest.sterbeurkunde.info.second',
      'app.submitRequest.sterbeurkunde.info.third',
    ],
  },
  commerzbank: {
    download: [
      'app.submitRequest.download.info.first',
      'app.submitRequest.download.info.third',
    ],
    upload: [
      'app.submitRequest.upload.info.first',
      'app.submitRequest.upload.info.third',
    ],
    password: [
      'app.submitRequest.password.info.first',
      'app.submitRequest.password.info.second',
      'app.submitRequest.password.info.third',
    ],
    additional: [
      'app.submitRequest.additional.info.first',
      'app.submitRequest.additional.info.second',
      'app.submitRequest.additional.info.third',
    ],
    sterbeurkunde: [
      'app.submitRequest.sterbeurkunde.info.first',
      'app.submitRequest.sterbeurkunde.info.second',
      'app.submitRequest.sterbeurkunde.info.third',
    ],
  },
};

export const ValidationFormMessages = {
  appointmentDate: {
    date: 'request.form.error.invalid.date',
    required: 'request.form.error.required.date',
  },
  emailAddress: {
    email: 'request.form.error.invalid.email',
    required: 'request.form.error.required.email',
  },
  bankEmployeeEmailAddress: {
    email: 'request.form.error.invalid.email',
    required: 'request.form.error.required.email',
  },
  mobileNumber: {
    required: 'request.form.error.required.mobile',
  },
  allowEmail: {
    required: 'request.form.error.required.allowEmail',
  },
};

export const Errors = {
  QRCODE_MISMATCH: 'QRCODE_MISMATCH',
};
